import { useState } from 'react';

import { AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline';

const SectionHeader = ({ title, centeredTitle = false, actionsLeft, actionsRight, mobileActionsBelow, extraClasses, actionsRightButtonText = 'Filters' }) => {
  const [areActionsRightOpen, setAreActionsRightOpen] = useState(false);

  const baseStyles = `flex flex-col md:flex-row md:items-center gap-2 md:gap-0 p-3 bg-ase-blue font-semibold rounded-t-md`;

  return (
    <div className={`${baseStyles} ${centeredTitle ? 'justify-center' : 'justify-between'} ${extraClasses}`}>
      <div className="flex items-center justify-between gap-2">
        <div className='flex items-center gap-2'>
          <h2 className="text-base text-white">{title}</h2>

          {actionsLeft && actionsLeft}
        </div>

        {actionsRight && (
          <button
            onClick={() => setAreActionsRightOpen(!areActionsRightOpen)}
            className='md:hidden bg-white rounded-md text-xs text-ase-blue font-semibold px-2 py-1 flex items-center gap-1'
          >
            <AdjustmentsHorizontalIcon className="h-4 w-4 text-ase-blue" />
            {actionsRightButtonText}
          </button>
        )}
      </div>

      {mobileActionsBelow && (
        <div className="md:hidden pt-2 pb-2 border-t border-b border-white/30 flex items-center gap-2">
          {mobileActionsBelow}
        </div>
      )}

      {actionsRight && (
        <div className={`md:flex gap-2 ${areActionsRightOpen ? 'flex' : 'hidden'}`}>
          {actionsRight}
        </div>
      )}
    </div>
  )
}

export default SectionHeader;
